// extracted by mini-css-extract-plugin
module.exports = {"faq-container":"plan-comparison-faq_faq-container___G4YI","faq-header":"plan-comparison-faq_faq-header__4MAx0","faq-answer":"plan-comparison-faq_faq-answer__Ei8Zf"};